// "What's new" feature tours, shown once per user after login.
//
// Tours are for NEW FEATURES only. Do not add entries for bug fixes, small UI
// tweaks or performance work: nothing here is automatic, a tour exists only
// if someone adds it to this list.
//
// To announce a new feature, add an entry at the TOP of this list and ship it
// in the same release as the feature:
//   id          unique and permanent — it is what marks the tour as seen, so
//               never rename or reuse one
//   releasedAt  YYYY-MM-DD; users created after this date never see the tour
//   roles       optional, e.g. ["ADMIN", "MANAGER"]; omit to show to everyone
//   permission  optional, an AdminUserPermissions value (src/utils/user-role.js),
//               or a list of them; the tour only shows to users who hold (any of) it
//   slides      one per step:
//     titleKey / textKey  i18n keys (add them to src/locales/en.json and ar.json)
//     media               screenshot, GIF, SVG or MP4 under public/feature-tours/
//     tryRoute            optional; adds a "Try it now" button that opens this route
//
// Keep media around 1200x675 (16:9) so every slide lines up.

const tours = [
  {
    id: "2026-09-customer-groups",
    releasedAt: "2026-09-23",
    // same gate as the "Customer Groups" menu item in MainNavbar
    permission: ["CUSTOMER_VIEW", "IN_ACTIVE_CUSTOMER_VIEW"],
    slides: [
      {
        titleKey: "featureTours.customerGroups.intro.title",
        textKey: "featureTours.customerGroups.intro.text",
        media: "/feature-tours/customer-groups-1-list.svg",
        tryRoute: "/customer-groups",
      },
      {
        titleKey: "featureTours.customerGroups.create.title",
        textKey: "featureTours.customerGroups.create.text",
        media: "/feature-tours/customer-groups-2-create.svg",
      },
      {
        titleKey: "featureTours.customerGroups.members.title",
        textKey: "featureTours.customerGroups.members.text",
        media: "/feature-tours/customer-groups-3-member.svg",
      },
      {
        titleKey: "featureTours.customerGroups.details.title",
        textKey: "featureTours.customerGroups.details.text",
        media: "/feature-tours/customer-groups-4-details.svg",
      },
      {
        titleKey: "featureTours.customerGroups.subscription.title",
        textKey: "featureTours.customerGroups.subscription.text",
        media: "/feature-tours/customer-groups-5-wizard.svg",
      },
      {
        titleKey: "featureTours.customerGroups.actions.title",
        textKey: "featureTours.customerGroups.actions.text",
        media: "/feature-tours/customer-groups-6-actions.svg",
        tryRoute: "/customer-groups",
      },
    ],
  },
  {
    id: "2026-09-whats-new",
    releasedAt: "2026-09-23",
    slides: [
      {
        titleKey: "featureTours.whatsNew.intro.title",
        textKey: "featureTours.whatsNew.intro.text",
        media: "/feature-tours/whats-new-intro.svg",
      },
      {
        titleKey: "featureTours.whatsNew.reopen.title",
        textKey: "featureTours.whatsNew.reopen.text",
        media: "/feature-tours/whats-new-reopen.svg",
      },
    ],
  },
];

export default tours;
